import { Button, Col, Form, Row } from "antd";
import React, { useState } from "react";
import CommentBox from "../../../components/commentBox";
import PageHeader from "../../../components/pageHeader";
import TaskCheckedList from "../../../components/taskCheckedList";
import { collection, doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../../../../../../../firebase";

function BreakingLease({ itemId, listId, alreadyCheckedItems }) {
  const isItemChecked = alreadyCheckedItems[itemId.toString()]; // Convert itemId to string because keys in checkedItems are strings.

  const [isDisabled, setIsDisabled] = useState(isItemChecked);

  const tasksRef = collection(db, "tasks");
  const itemListRef = doc(tasksRef, "itemList");
  const assignedCollectionRef = collection(itemListRef, "Assigned");

  const handleComplete = async () => {
    const targetDocRef = doc(assignedCollectionRef, listId);

    try {
      const docSnapshot = await getDoc(targetDocRef);

      if (docSnapshot.exists()) {
        const data = docSnapshot.data();
        if (data && data.workItemList) {
          const updatedWorkItemList = data.workItemList.map((item) => {
            return {
              ...item,
              status:
                item.id == itemId && item.status == "incompleted"
                  ? "completed"
                  : item.status,
            };
          });

          await updateDoc(targetDocRef, {
            workItemList: updatedWorkItemList,
          });

          console.log("Document successfully updated!");
          setIsDisabled(true);
        } else {
          console.log("workItemList not found in the document!");
        }
      } else {
        console.log("Document does not exist!");
      }
    } catch (error) {
      console.error("Error updating document:", error);
    }
  };
  return (
    <div className="item-page">
      <Form className="item-page-container" layout="vertical">
        <Row gutter={[0, 24]}>
          <Col span={24}>
            <PageHeader pageHeading="Breaking Lease" />
          </Col>
          <Col span={24}>
            <Row gutter={[0, 16]}>
              <Col span={24}>
                <h3 className="green-info-text">
                  Send this email to the tenant in appfolio- put the address in
                  the subject line
                </h3>
              </Col>
              <Col span={24}>
                {" "}
                <p className="green-info-text">
                  We have received your notice to vacate but have found that
                  your lease is not yet up per your contract. Per our policies
                  you have 2 basic options to close out your lease.
                </p>
              </Col>
              <Col span={24}>
                {" "}
                <p className="green-info-text">
                  1. Complete your full lease until the final date listed on the
                  agreement. In this situation you would continue to pay all
                  rent and fees and maintain the property and utilities until
                  the final day of your lease.{" "}
                </p>
              </Col>
              <Col span={24}>
                <p className="green-info-text">
                  2. Pay the lease break fees as follows:
                </p>
              </Col>
              <Col span={24}>
                {" "}
                <p className="green-info-text">
                  -pay rent in full until your agreed on move out date
                </p>
              </Col>
              <Col span={24}>
                <p className="green-info-text">
                  -pay a fee of 1 and 1/2 months rent (eg - rent $1000 so fee
                  would be $1500)
                </p>
              </Col>
              <Col span={24}>
                <p className="green-info-text">
                  -forfeit your security deposit in full in addition to paying
                  the lease break fee.
                </p>
              </Col>
              <Col span={24}>
                <p className="green-info-text">
                  -leave the home in move in ready condition (any damages left
                  would be billed to you and payment required or it would be
                  sent on to our collections agency.)
                </p>
              </Col>
              <Col span={24}>
                <p className="green-info-text">
                  Please reply back to this message and let me know how you
                  would like to proceed.
                </p>
              </Col>
            </Row>
          </Col>
          <Col span={24}>
            <Row gutter={[0, 16]}>
              <Col span={24}>
                <h3 className="blue-info-text red-info-heading">
                  If the tenant elects to break the lease
                </h3>
              </Col>
              <Col span={24}>
                <h3 className="blue-info-text red-info-heading">
                  -Enter a charge of 1 and 1/2 months rent on their ledger (now)
                </h3>
              </Col>
              <Col span={24}>
                <h3 className="blue-info-text red-info-heading">
                  -Enter a charge equal to their security deposit on their
                  ledger. (after they move out)
                </h3>
              </Col>
            </Row>
          </Col>
          <Col span={24}>
            <Row justify="end" gutter={[8, 0]}>
              <Col>
                <Button>Skip</Button>
              </Col>
              <Col>
                <Button
                  type="primary"
                  onClick={handleComplete}
                  disabled={isDisabled}
                >
                  Complete
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <CommentBox />
          </Col>
          <Col span={24}>
            <TaskCheckedList />
          </Col>
        </Row>
      </Form>
    </div>
  );
}

export default BreakingLease;
